import { gql } from '@apollo/client'

export const CREATE_PROCESSING_BY_FEEDBACK_MUTATION = gql`
  mutation createProcessingByFeedback($feedbackId: ID!, $attributes: ProcessingInput) {
    createProcessingByFeedback(feedbackId: $feedbackId, attributes: $attributes) {
      id
    }
  }
`
